exports.default = void 0;

var _default = [
  {
    key: "multiple",
    ignore: true,
  },
  {
    type: "datagrid",
    input: true,
    label: "Values",
    key: "values",
    tooltip:
      "The radio button values that can be picked for this field. Values are text submitted with the form data. Labels are text that appears next to the radio buttons on the form.",
    weight: 10,
    reorder: true,
    defaultValue: [
      {
        label: "",
        value: 0,
      },
    ],
    components: [
      {
        label: "Label",
        key: "label",
        input: true,
        type: "textfield",
      },
      {
        label: "Value",
        key: "value",
        input: true,
        type: "textfield",
        allowCalculateOverride: false,
        calculateValue: {
          _camelCase: [
            {
              var: "rowIndex",
            },
          ],
        },
      },
      {
        type: "number",
        input: true,
        weight: 180,
        label: "Weight",
        key: "weight",
        tooltip: "The weight of this option only usable inside of sumatories.",
        dataSrc: "custom",
        valueProperty: "value",
        customDefaultValue: function customDefaultValue() {
          return "";
        },
        template: "{{ item.label }}",
      },
    ],
  },
  {
    type: "select",
    input: true,
    label: "Storage Type",
    key: "dataType",
    clearOnHide: true,
    tooltip:
      "The type to store the data. If you select something other than autotype, it will force it to that type.",
    weight: 12,
    template: "<span>{{ item.label }}</span>",
    dataSrc: "values",
    data: {
      values: [
        {
          label: "Autotype",
          value: "auto",
        },
        {
          label: "String",
          value: "string",
        },
        {
          label: "Number",
          value: "number",
        },
        {
          label: "Boolean",
          value: "boolean",
        },
        {
          label: "Object",
          value: "object",
        },
      ],
    },
  },
  {
    key: "encrypted",
    ignore: true,
  },
  {
    key: "persistent",
    ignore: true,
  },
];
exports.default = _default;
